import { i18n } from "i18next-ko";
import { singleton } from "tsyringe";
import { Client } from "../../tracejs/src/net/jsonrpc/Client";
import {TracedoGroup} from "../entities/TracedoGroup";
import {Tracedo} from "../entities/Tracedo";
import {DistributionPriceListPrice} from "../entities/DistributionPricelistPrice";
import {CodelistManager} from "./CodelistManager";

@singleton()
export class TracedoManager
{

	/**
	 * RPC Client
	 */
    private rpc: Client;
    private codelistManager: CodelistManager;

    /**
     * Constructor
     * @param rpc RPC
     */
    constructor(rpc: Client, codelistManager: CodelistManager)
    {
        this.rpc = rpc;
        this.codelistManager = codelistManager;
    }

    public async getTracedoWithId(tracedoId: number): Promise<Tracedo> {
        return await this.rpc.call('tracedo.getOne', {
            id: tracedoId,
            query: {
                select: '*,' +
                    'customerPartner(*),customerPartnerPicUser(*),' +
                    'supplierPartner(*),supplierPartnerPicUser(*),' +
                    'mySubject(*),myPicUser(*),myInvoicingStatus(*),myPassStatus(*),myPassedFromStatus(*),mySeason(*),' +
                    'purchasePriceCurrency(*),sellPriceCurrency(*),' +
                    'mode(*),kind(*),roadType(*),bdpCntrType(*),truckType(*),' +
                    'driverUser(*),trcStatus(*),createdUser(*),deliveryContact(*),depot(*),pickupContact(*),poItems(*),' +
                    'checkpoints(*, ramp(*)),' +
                    'deliveryAddress(country),destAddressCountry(*),pickupAddress(country),' +
                    'originRamp(*),destinationRamp(*),' +
                    'incoterms(*),' + 'parent(myNumber)',
                criteria: {
                    checkpoints: {
                        sort: [{field: 'posIndex', dir: 'asc'}]
                    }
                }
            }
        });
    }

    public async getMyNumberForTracedoId(tracedoId: number): Promise<Tracedo> {
        // TODO: FIX to send only the tracedo myNumber
        return await this.rpc.call('tracedo.getOne', {
            id: tracedoId,
            query: {
                select: '*'
            }
        });
    }

	/**
     * Přerušit přepravu (nastavit stav suspend, odstraní řidiče z přepravy a odešle mu notifikaci)
     */
    public async suspend(tracedoId: number): Promise<any>
    {
        return await this.rpc.call('tracedo.suspend', { id: tracedoId });
    }

    /**
     * Zrušit přepravu (nastavit stav cancel + odešle email notifikaci)
     */
    public async cancel(tracedoId: number): Promise<any>
    {
        return await this.rpc.call('tracedo.cancel', { id: tracedoId });
    }
    
    /**
     * Generovani objednavky pozemni prepravy
     * @param tracedoId Tracedo ID
     * @param asRole 'customer' = jsem zakaznik, objednavam na dopravce NEBO 'supplier' = jsem dopravce, prijata objednavka od zakaznika
     * @param format 'pdf', 'html'
     */
    public async generateTransportOrder(tracedoId: number, asRole: string, format: string): Promise<any>
    {
        return await this.rpc.call('tracedo.generateTransportOrder', { 
            id: tracedoId,
            asRole: asRole,
            format: format
        });
    }

    public async getPrice(tracedo: MappedType<Tracedo>): Promise<DistributionPriceListPrice | null> {
        let price: { price: number, currencyId: number } | null = await this.rpc.call('distributionPricelist.getPrice', { tracedo: ko.mapping.toJS(tracedo) });

        if (price === null) return null;

        let currency = this.codelistManager.getOneCurrency(price.currencyId);

        return {
            price: price.price,
            currency: currency
        };
    }

    /**
     * Generovani objednavky pozemni prepravy
     * @param tracedoId Tracedo ID
     * @param asRole 'customer' = jsem zakaznik, objednavam na dopravce NEBO 'supplier' = jsem dopravce, prijata objednavka od zakaznika
     */
    public async getTransportOrderHtml(tracedoId: number, asRole: string): Promise<any>
    {
        return await this.rpc.call('tracedo.generateTransportOrder', {
            id: tracedoId,
            asRole: asRole,
            format: 'html',
            returnContent: true
        });
    }

    /**
     * Konverze HTML do PDF
     * @param html 
     * @returns 
     */
    public async saveAsPdf(html: string, fileName: string): Promise<any>
    {
        return await this.rpc.call('report.htmlToPdf', { html: html, fileName: fileName });
    }
}